var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"form-background pa-4 fill-height",attrs:{"flat":""}},[_c('v-card',{attrs:{"max-width":"600","min-height":"500"}},[_c('loginFormComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }